export default {
  azmoon: {
    azmoonExecutes: "v1/azmoon_execute",
    azmoonExecute: "v1/azmoon_execute/{0}",
    azmoonExecuteDetails: "v1/azmoon_execute/{0}/details",
    azmoonExecutePersons: "v1/azmoon_execute/{0}/person",
    azmoonExecutePerson: "v1/azmoon-execute-person/{0}",
    azmoonExecutePersonSetAbsent: "v1/azmoon-execute-person/{0}/set-absent",
    azmoonExecutePersonAttachments: "v1/azmoon-execute-person/{0}/attachment",
    azmoonExecutePersonAttachment:
      "v1/azmoon-execute-person/{0}/attachment/{1}",
    rebuildReport: "v1/rebuild-report",
    rebuildAzmoonIntegratedReport: "v1/rebuild-azmoon-integrated-report",
    azmoonExecutePersonExamPacks:
      "v1/azmoon-execute/{0}/person/{1}/operator/{2}/reference/{3}",
    azmoonExecuteShowTimeControl:
      "v1/azmoon_execute_person/{0}/show_time_control",
    azmoonExecuteTime: "v1/azmoon_execute_time/{0}",
    azmoonExecuteAttachments: "v1/azmoon-execute/{0}/attachment",
    azmoonExecuteAttachment: "v1/azmoon-execute/{0}/attachment/{1}",
    rebuildAllAzmoonReports: "v1/rebuild-all-azmoon-reports",
    azmoonExecuteImportPerson: "v1/azmoon_execute/{0}/import-person",
    azmoonExecuteExamPacks: "v1/azmoon_execute/{0}/exam_pack",
    azmoonExecuteExamPack: "v1/azmoon_execute/{0}/exam_pack/{1}",
    azmoonExecuteExamPackImportAnswers:
      "v1/azmoon_execute/{0}/exam_pack/{1}/import_answers",
    azmoonExecuteExamPackMakeReport:
      "v1/azmoon_execute/{0}/exam_pack/{1}/make_report",
    azmoonExecuteExamPacksOrder: "v1/azmoon_execute_exam_packs/order",
    azmoonExecuteExamPackRequirements:
      "v1/azmoon_execute/{0}/exam_pack/{1}/requirements",
    azmoonExecuteExamPackRequirement:
      "v1/azmoon_execute/{0}/exam_pack/{1}/requirement",
    titles: "v1/title",
    title: "v1/title/{0}",
    options: "v1/option",
    option: "v1/option/{0}",
    rebuildAzmoonReport: "v1/rebuild-azmoon-report",
    azmoonExecuteActivityAttachments:
      "v1/fa/azmoon/attachment-azmoon-execute-activity/{0}",
    azmoonExecuteActivityAttachment:
      "v1/fa/azmoon/attachment-azmoon-execute-activity/{0}/attachment/{1}",
    examPackImport: "v1/exam_pack/import",
    examPackId: "v1/exam_pack/{0}",
    examPackDetails: "v1/exam_pack/{0}/clone",
    examPackExport: "v1/exam_pack/{0}/export",
    examPack: "v1/exam_pack",
    questionRepo: "v1/question",
    titleList: "v1/title",
    analysisAlgorithm: "v1/analysis_algorithm_combo",
    question: "v1/question",
    questionId: "v1/question/{0}",
    questionClone: "v1/question/{0}/clone",
    examPackChildren: "v1/exam_pack/{0}/children",
    examPackQuestionId: "v1/exam_pack/{0}/question",
    examPackChild: "v1/exam-pack-child",
    examPackChildId: "v1/exam-pack-child/{0}",
    examPackIdQuestionId: "v1/exam_pack/{0}/question/{1}",
    allQuestion: "v1/exam_pack/{0}/all_question",
    porseshnamehList: "v1/fa/porseshnameh/azmoon-execute/{0}/porseshnameh",
    porseshnamehByCode: "v1/fa/porseshnameh/azmoon-execute-porseshnameh/{0}",
    v2: {
      options: "v2/fa/azmoon/option",
    },
  },
};
